import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

// actions
import * as Actions from "actions";

// helpers
import { getJsonFromUrl } from "helpers";

// component
import WrapperMyAccountPage from "../component/WrapperMyAccountPage";

const mapStateToProps = (state) => ({
  user: state.user,
  userApps: state.userApps,
  accessTokens: state.accessTokens,
});

const mapDispatchToProps = (dispatch) => ({
  getCurrentUser: (...args) => dispatch(Actions.getCurrentUser(...args)),
  updateUser: (...args) => dispatch(Actions.updateUser(...args)),
  updateUserPassword: (...args) =>
    dispatch(Actions.updateUserPassword(...args)),
  getAccessTokens: (...args) => dispatch(Actions.getAccessTokens(...args)),
  createAccessToken: (...args) => dispatch(Actions.createAccessToken(...args)),
  updateAccessToken: (...args) => dispatch(Actions.updateAccessToken(...args)),
  deleteAccessToken: (...args) => dispatch(Actions.deleteAccessToken(...args)),
  getOrganizations: () => dispatch(Actions.getOrganizations()),
  getOrganizationById: (...args) =>
    dispatch(Actions.getOrganizationById(...args)),
  createOrganization: (...args) =>
    dispatch(Actions.createOrganization(...args)),
  deleteOrganization: (...args) =>
    dispatch(Actions.deleteOrganization(...args)),
  deleteOrganizationUser: (...args) =>
    dispatch(Actions.deleteOrganizationUser(...args)),
  updateOrganization: (...args) =>
    dispatch(Actions.updateOrganization(...args)),
  getOrganizationUsers: (...args) =>
    dispatch(Actions.getOrganizationUsers(...args)),
  addUserToOrganization: (...args) =>
    dispatch(Actions.addUserToOrganization(...args)),
  joinOrganization: (...args) => dispatch(Actions.joinOrganization(...args)),
});
class MyAccountPage extends React.Component {
  static propTypes = {
    user: PropTypes.object,
    userApps: PropTypes.array,
    getCurrentUser: PropTypes.func,
    updateUser: PropTypes.func,
    updateUserPassword: PropTypes.func,
    history: PropTypes.object,
    location: PropTypes.object,

    accessTokens: PropTypes.array,
    getAccessTokens: PropTypes.func,
    createAccessToken: PropTypes.func,
    updateAccessToken: PropTypes.func,
    deleteAccessToken: PropTypes.func,

    organizations: PropTypes.array,
    getOrganizations: PropTypes.func,
    getOrganizationById: PropTypes.func,
    createOrganization: PropTypes.func,
    deleteOrganization: PropTypes.func,
    updateOrganization: PropTypes.func,
    getOrganizationUsers: PropTypes.func,
    addUserToOrganization: PropTypes.func,
    deleteOrganizationUser: PropTypes.func,
    joinOrganization: PropTypes.func,
  };

  constructor(...args) {
    super(...args);
    const { location } = this.props;

    this.state = {
      urlParams: getJsonFromUrl(location),
    };
  }

  componentDidMount() {
    this.refresh();
  }

  refresh() {
    const { getCurrentUser, getAccessTokens } = this.props;
    return Promise.all([getAccessTokens(), getCurrentUser()]);
  }

  render() {
    const { urlParams } = this.state;

    const {
      user,
      history,
      updateUser,
      updateUserPassword,
      getAccessTokens,
      createAccessToken,
      updateAccessToken,
      deleteAccessToken,
      accessTokens,
      getOrganizationById,
      createOrganization,
      deleteOrganization,
      updateOrganization,
      getOrganizationUsers,
      deleteOrganizationUser,
      addUserToOrganization,
      joinOrganization,
      getOrganizations,
      userApps,
    } = this.props;

    return (
      <WrapperMyAccountPage
        history={history}
        refresh={this.refresh.bind(this)}
        user={user}
        updateUser={updateUser}
        updateUserPassword={updateUserPassword}
        urlParams={urlParams}
        getOrganizations={getOrganizations}
        getAccessTokens={getAccessTokens}
        createAccessToken={createAccessToken}
        updateAccessToken={updateAccessToken}
        deleteAccessToken={deleteAccessToken}
        accessTokens={accessTokens}
        userApps={userApps}
        organizations={user.organizations}
        getOrganizationById={getOrganizationById}
        createOrganization={createOrganization}
        deleteOrganization={deleteOrganization}
        updateOrganization={updateOrganization}
        getOrganizationUsers={getOrganizationUsers}
        deleteOrganizationUser={deleteOrganizationUser}
        addUserToOrganization={addUserToOrganization}
        joinOrganization={joinOrganization}
      />
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(MyAccountPage);
